import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import 'react-toastify/dist/ReactToastify.css';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import { ExpiredMessage } from './expired_message';
import { KeepAliveMessage } from './keep_alive_message';

export const BookingExpiry = ({ bookingDidExpire }) => {
  const booking = useSelector(getCurrentBooking);
  const { expires_from: expiresFrom, state: bookingState } = booking;
  const warningTimeInMillis = 300000; // 5 minutes

  useEffect(() => {
    if (bookingState !== 'new') {
      return undefined;
    }

    const expiryDate = new Date(expiresFrom);
    const now = new Date();

    const ttlMillis = expiryDate - now;

    let warningToastId;
    let warningID;

    if (expiryDate > now) {
      warningID = setTimeout(() => {
        warningToastId = toast.warn(<KeepAliveMessage />, {
          autoClose: ttlMillis,
          pauseOnHover: false,
          pauseOnFocusLoss: false,
          draggable: false,
          closeOnClick: false,
          hideProgressBar: false,
        });
      }, Math.max(ttlMillis - warningTimeInMillis, 0));
    }

    let expiredToastId;
    const expiredID = setTimeout(() => {
      toast.dismiss(warningToastId);

      expiredToastId = toast.error(
        <ExpiredMessage bookingDidExpire={bookingDidExpire} />,
        {
          autoClose: false,
        }
      );
    }, Math.max(ttlMillis, 0));

    return () => {
      toast.dismiss(warningToastId);
      toast.dismiss(expiredToastId);
      clearTimeout(warningID);
      clearTimeout(expiredID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresFrom]);

  if (isEmpty(expiresFrom)) {
    return null;
  }

  return <ToastContainer icon={false} />;
};

BookingExpiry.propTypes = {
  bookingDidExpire: PropTypes.func,
};
